@if (!showIframe) {
<div class="page gray-font-color font-family">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()" data-test="back-arrow-button" data-testid="back-arrow-button">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div class="header-text" data-testid="dqf-declaration-header">{{ pageTitle }}</div>
  </div>
  <div fxFlex="95" class="header-text">{{ pageTitle }}</div>

  <div *ngIf="!buttonText">
    <app-loading-gif></app-loading-gif>
  </div>
  <div *ngIf="buttonText">
    <div class="content" *ngIf="!isContentReady">
      <app-dqf-document-skeleton></app-dqf-document-skeleton>
    </div>
    <div *ngIf="isContentReady && isDocumentProcessing" class="container-loading-gif">
      <div fxLayoutAlign="center">
        <img src="/assets/icons/FleetOperate load.gif" />
      </div>
      <div fxLayoutAlign="center" class="loading-text">
        Getting ready with your {{ pageTitle }} form.<br />Please come back after few minutes...
      </div>
    </div>
    <div *ngIf="isContentReady && isRejected">
      <div class="rejection-banner">
        <div class="description" data-testid="dqf-declaration-rejected">Declaration rejected. Please Delete to restart</div>
      </div>
      <div class="btn-delete-container">
        <button mat-stroked-button class="btn-delete" (click)="deleteDocument()" data-testid="delete-declaration">
          <mat-icon svgIcon="delete-icon" class="delete-icon" data-test="delete-declaration-icon" data-testid="delete-declaration-icon"></mat-icon>Delete
          Declaration
        </button>
      </div>
    </div>
    <div class="content" [ngClass]="{ 'display-none': !isContentReady || isDocumentProcessing }" *ngIf="!isRejected">
      <div class="declaration-card">
        <div class="status-header">
          <div class="status-icon">
            <mat-icon svgIcon="check-circle" class="success-icon"></mat-icon>
          </div>
          <div class="status-content">
            <h3 class="status-title" data-testid="dqf-declaration-title">{{ declarationLabel }}</h3>
            <p class="status-subtitle" *ngIf="generationDate">Completed on {{ generationDate }}</p>
          </div>
        </div>
        
        <div class="declaration-details" *ngIf="generationDate">
          <div class="detail-item">
            <mat-icon svgIcon="calendar-line" class="detail-icon"></mat-icon>
            <div class="detail-content">
              <span class="detail-label">Signature Date</span>
              <span class="detail-value">{{ generationDate }}</span>
            </div>
          </div>
        </div>
        
        <div class="action-section" *ngIf="buttonText">
          <button mat-raised-button class="btn-view-declaration" (click)="buttonAction()" [disabled]="!isContentReady"
            data-test="sign-in-declaration"
            data-testid="sign-in-declaration">
            <mat-icon svgIcon="ball-pen" class="button-icon"></mat-icon>
            {{ buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}
<ng-container *ngIf="showIframe">
  <div class="signing-iframe-wrapper">

    <iframe [src]="zohoSigningUrl" width="100%" height="100%" frameborder="0" allowfullscreen class="signing-iframe"
      id="iframe_callback" #iframe_callback
      sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation allow-top-navigation-by-user-activation"
      allow="camera; microphone; geolocation">
    </iframe>
  </div>
</ng-container>